import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { ListGroup } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './EditTeamProfileTeamList.scss'
import { getTeamsByPlayer } from '@severed-links/common.redherrings-reducers/football'
import PlayerTeam from '../PlayerTeam'
import RHPicker from '@severed-links/common.picker'

const EditTeamProfileTeamList = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()
    const _path = `/football/edit-team-profile/:teamId`
    const teamId = params.teamId || null
    const playerId = useSelector(state => state.account._id)
    const teams = useSelector(state => state.football.editProfileTeams)
        .map(i => ({ ...i, isActiveTeam: i.teamId === teamId }))
    const [showTeamPicker, setShowTeamPicker] = useState(false)
    const activeTeam = teams.find(team => team.isActiveTeam) || teams[0]

    useEffect(() => { getTeamList() }, [playerId])

    const getTeamList = () => playerId ? dispatch(getTeamsByPlayer(playerId)) : null

    const onSelectTeam = selectedTeamId => navigate(_path.replace(':teamId', selectedTeamId))

    const pickerItems = teams.map(team => ({
        title: team.teamName,
        subtitle: team.seasonName,
        value: team.teamId,
        right: <PlayerTeam teamId={team.teamId} avatarUrl={team.avatarUrl}
            showTeamName={false} setWidth='36px' setHeight='36px' />,
    }))

    return (
        <>
        <div className={s.mobilePicker}>
            <button type='button' className={s.mobilePickerButton} onClick={() => setShowTeamPicker(true)}>
                <div className={s.mobilePickerLabel}>Team to edit</div>
                <div className={s.mobilePickerContent}>
                    {activeTeam ?
                    <PlayerTeam teamId={activeTeam.teamId}
                        teamName={`${activeTeam.seasonName} ${activeTeam.teamName}`}
                        avatarUrl={activeTeam.avatarUrl} />
                    : <span>Select a team</span>}
                    <FontAwesomeIcon name='chevron-down' className={s.mobilePickerIcon} />
                </div>
            </button>
        </div>
        <div className={s.container}>
            <div className={s.heading}>
                <div>
                    <div className={s.eyebrow}>Seasons</div>
                    <h3>Your teams</h3>
                </div>
                {teams.length > 0 ? <span className={s.count}>{teams.length}</span> : null}
            </div>
            <ListGroup className={s.teamList}>
            {teams && teams.map(t =>
            <ListGroup.Item className={s.pastTeamItem + (t.isActiveTeam ? ` ${s.active}` : '')}
                action onClick={() => onSelectTeam(t.teamId)}
                key={`edit-profile-team-${t.teamId}`}>
                <div>
                    <PlayerTeam teamId={t.teamId} teamName={t.seasonName + ' ' + t.teamName} avatarUrl={t.avatarUrl} />
                </div>
                {t.isActiveTeam ? <FontAwesomeIcon name='chevron-right' className={s.icon} /> : null}
            </ListGroup.Item>
            )}
            </ListGroup>
        </div>
        <RHPicker show={showTeamPicker}
            heading='Choose a team to edit'
            items={pickerItems}
            defaultValue={teamId}
            showFilterBar={teams.length > 10}
            onSelect={item => onSelectTeam(item.value)}
            onClose={() => setShowTeamPicker(false)} />
        </>
    )
}

export default EditTeamProfileTeamList
